import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Title from "@components/CustomTypography/Title/Title"
import {
	AdvancedSideAssetModuleType,
	LogosModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"
import Marquee from "react-fast-marquee"

import styles from "./LogoSlider.module.scss"

type Props = {
	data: LogosModuleType[]
	content: AdvancedSideAssetModuleType
}

const LogoSlider = (props: Props) => {
	return (
		<section>
			<Separator size={128}>
				<ContainerWrapper>
					<Title
						className={styles.title}
						content={props.content.sectionTitle}
						size={"XL"}
						center
					/>
					<Separator />
				</ContainerWrapper>
				<Marquee className={styles.logosBox} speed={100} pauseOnHover>
					{props.data.map(
						(element: LogosModuleType, index: number) => {
							return (
								<NewResponsiveImage
									key={index}
									imageClassName={styles.image}
									withoutContainer
									{...element.logo}
								/>
							)
						},
					)}
				</Marquee>
			</Separator>
		</section>
	)
}

export default LogoSlider
